import styled from 'styled-components';

const formWidth = '870px';

export const SelectField = styled.input``;

export const FormInputGroupWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;

  gap: 40px;
`;

export const Section = styled.div`
  align-self: center;
`;

export const FormInputWrapper = styled.div`
  width: 100%;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  select {
    padding: 4px 20px 4px 8px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    touch-action: manipulation;
    appearance: none;
    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' standalone='no'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg t='1597601650772' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='1210' xmlns:xlink='http://www.w3.org/1999/xlink' width='16' height='16'%3E%3Cdefs%3E%3Cstyle type='text/css'%3E%3C/style%3E%3C/defs%3E%3Cpath d='M726.652801 429.305603 297.347199 429.305603 512.193405 638.156258Z' p-id='1211'%3E%3C/path%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right;

    &:focus {
      border-color: #40a9ff;
      border-right-width: 1px !important;
      outline: 0;
      -webkit-box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }

    &:hover {
      border-color: #40a9ff;
      border-right-width: 1px !important;
    }
  }

  input:disabled:hover {
    border-color: rgba(0, 0, 0, 0.3);
  }

  input,
  .ant-input-affix-wrapper,
  select,
  textarea {
    border-radius: 3px;
  }
`;

export const FormSmallWrapper = styled(FormInputWrapper)`
  width: 40%;
`;

export const FormExtraSmallWrapper = styled(FormInputWrapper)`
  width: 15%;
`;

export const FormSelectWrapper = styled(FormInputWrapper)`
  width: min-content;

  & > label:first-child {
    width: max-content;
  }
`;

export const FormLabel = styled.label`
  font-size: 14px;
`;

export const MessageBox = styled.div`
  color: red;
  font-size: 12px;
`;

export const Outlet = styled.div`
  width: 100%;
  background-color: #fff;
  border-radius: 3px;
  padding: 24px;
`;

export const StationPaymentFormGrid = styled.div`
  display: flex;
  width: 100%;
`;

export const StationPaymentFormWrapper = styled.div`
  width: ${formWidth};
`;

export const StationMapWrapper = styled.div`
  position: relative;
  height: 500px;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  margin: 0;
  display: flex;
  justify-content: flex-end;
  border-radius: 3px;

  & > .map-container {
    width: 100%;
    height: 100%;
  }
`;

export const AddressSection = styled.div`
  align-self: center;
  margin-bottom: 20px;
`;

export const SwitchWrapper = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
`;

export const AdvancedSettings = styled.div`
  flex: 1;
`;

// Significado da rotação escolhida (MV2-2006)
export const PhaseRotationHint = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.55);
`;

export const ConnectorTabs = styled.div<{ $flush?: boolean }>`
  width: 100%;
  margin-top: ${({ $flush }) => ($flush ? '-12px' : '24px')};

  && .ant-tabs-top > .ant-tabs-nav {
    margin-bottom: 12px;
  }

  && .ant-tabs-tab {
    padding-top: ${({ $flush }) => ($flush ? '0' : '12px')};
  }
`;
